import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const homeHero = () => {
	const homeHero = document.querySelector(".jbg-home-hero");
	if (!homeHero) return;

	const gradient = document.querySelector(".jbg-highlights__gradient");

	// Allows the gradient to be invisble when at top of page
	// and then animates into height and position as user scrolls
	gsap.from(gradient, {
		top: 0,
		height: 0,
		scrollTrigger: {
			trigger: homeHero,
			start: "top top",
			end: "100px",
			scrub: true,
		},
	});
};

export default homeHero;
